import type { LoanInput } from "../types";

const KEY = "azure-rate-check-deal";

export type SavedDeal = {
  loan: LoanInput;
  rateText: string;
  yearsText: string;
  valueText: string;
  offsetText: string;
};

function complete(loan: LoanInput | undefined): loan is LoanInput {
  return Boolean(loan && loan.rate > 0 && loan.balance > 0 && loan.years > 0);
}

export function loadDeal(): SavedDeal | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as SavedDeal;
    if (!complete(parsed.loan)) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function saveDeal(deal: SavedDeal): void {
  try {
    if (!complete(deal.loan)) return;
    localStorage.setItem(KEY, JSON.stringify(deal));
  } catch {
    /* private mode */
  }
}

export function clearSavedDeal(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* private mode */
  }
}
